import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ApiBackend from '@services/languages/i18nBackend';

// Configuração do backend para carregar traduções da API
const backendOptions = {
  group: 'play', // grupo das traduções na API
};

i18n
  // Backend customizado que carrega traduções da API
  .use(ApiBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'br',
    backend: backendOptions,
    fallbackLng: 'br',
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    // can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand
    // ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
